module.exports = __webpack_public_path__ + "static/media/img3-4.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/biosense/diff/img3-4.png
// module id = 1707
// module chunks = 3